import { render, staticRenderFns } from "./PermissionsPromptModal.vue?vue&type=template&id=492896ae&"
import script from "./PermissionsPromptModal.vue?vue&type=script&lang=js&"
export * from "./PermissionsPromptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PermissionsPromptModal.vue"
export default component.exports